export class ServerStatusResponse {
    constructor(
        readonly datagrunnlag_sist_oppdatert: string,
        readonly datakatalog: { dato: string; id: number; versjon: string }
    ) {}
}
